import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../../core/services/account.service';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslateModule, RouterModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})

export class HeaderComponent {
  currentLang: string = "";
  constructor(private elementRef: ElementRef, public translateService: TranslateService, private renderer: Renderer2,
    public accountService: AccountService, private router: Router
  ) {
    this.currentLang = this.translateService.currentLang || 'ar-SA';
    this.updateDirection(this.currentLang);
  }

  profileDropDownActions: boolean = false;
  showUserDropdownActions(): void {
    this.profileDropDownActions = !this.profileDropDownActions;
  }

  // logic of hide and show actions dropdown
  @HostListener('document:mouseup', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const container = this.elementRef.nativeElement.querySelector('.profile-popup-links');
    const notify = this.elementRef.nativeElement.querySelector('.profile-sec');

    if (container && notify) {
      const isClickInsideContainer = container.contains(event.target as Node);
      const isClickInsideNotify = notify.contains(event.target as Node);

      if (!isClickInsideContainer && !isClickInsideNotify) {
        this.profileDropDownActions = !this.profileDropDownActions;
      }
    }
  };
  switchLanguage() {
    const currentLang = this.translateService.currentLang;
    const newLang = currentLang === 'ar-SA' ? 'en-US' : 'ar-SA';
    this.translateService.use(newLang);
    localStorage.setItem('selectedLang', newLang);

    const dir = newLang === 'ar-SA' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', newLang);
    setTimeout(() => {
      location.reload();
    }, 100);
  }
  updateDirection(lang: string) {
    const dir = lang === 'ar-SA' ? 'rtl' : 'ltr';
    this.renderer.setAttribute(document.documentElement, 'dir', dir);
    this.renderer.setAttribute(document.documentElement, 'lang', lang);
  }
  logout() {
    this.accountService.logout().subscribe({
      next: () => {
      },
      error: (error) => {
       this.accountService.clearUserData();
      }
    });
    this.router.navigateByUrl("/login");
  }
}
